module.exports = __webpack_public_path__ + "img/renault_zoe.6c4c0ec8.jpg";